<template lang="html">
    <transition name="dialog-t">
        <div
            v-if="active"
            ref="con"
            :class="[`vs-dialog-${color}`]"
            class="vs-component con-vs-dialog"
        >
            <div class="vs-dialog-dark" @click="handleClickOutside" />
            <div ref="dialogx" class="vs-dialog" style="min-width: 600px; width: fit-content">
                <header :style="styleHeader" class="vs-dialog-header">
                    <div class="con-title-after">
                        <span :style="styleAfter" class="after" />
                        <h3 class="dialog-title">
                            <slot name="header">
                                {{ title }}
                            </slot>
                        </h3>
                    </div>
                    <vs-icon
                        v-if="!hideCloseButton"
                        :icon="closeIcon"
                        :icon-pack="iconPack"
                        class="vs-dialog-cancel vs-dialog-cancel--icon notranslate"
                        @click.native="handleClose"
                    />
                </header>
                <div class="vs-dialog-text">
                    <slot />
                    {{ text }}
                </div>
                <!-- footer buttons -->
                <transition name="slide-fade" appear>
                    <footer v-if="!buttonsHidden">
                        <div class="w-full relative" style="height: 6px">
                            <div class="w-full flex justify-end absolute gap-2">
                                <slot name="footer">
                                    <slot name="cancel">
                                        <vx-button
                                            v-if="!hideCancel && showCancel"
                                            :color="cancelColor"
                                            @click="handleCancel"
                                        >
                                            {{ cancelText }}
                                        </vx-button>
                                    </slot>
                                    <slot name="accept">
                                        <vx-button
                                            v-if="!hideAccept && showAccept"
                                            :class="{
                                                disabled: isValid == 'none' ? false : !isValid
                                            }"
                                            :color="acceptColor"
                                            @click="acceptDialog"
                                        >
                                            {{ acceptText }}
                                        </vx-button>
                                    </slot>
                                </slot>
                            </div>
                        </div>
                    </footer>
                </transition>
            </div>
        </div>
    </transition>
</template>

<script>
import _color from '@/assets/utils/color.js'

export default {
    name: 'vx-prompt',
    props: {
        color: {
            default: 'primary',
            type: String
        },
        active: {
            default: false,
            type: Boolean
        },
        isValid: {
            default: 'none',
            type: [Boolean, String]
        },
        acceptText: {
            default: 'Accept',
            type: String
        },
        acceptColor: {
            default: 'success',
            type: String
        },
        hideCloseButton: {
            type: Boolean,
            default: false
        },
        hideAccept: {
            type: Boolean,
            default: false
        },
        hideCancel: {
            type: Boolean,
            default: false
        },
        cancelText: {
            default: 'Cancel',
            type: String
        },
        cancelColor: {
            default: 'warning',
            type: String
        },
        iconPack: {
            default: 'material-icons',
            type: String
        },
        closeIcon: {
            default: 'close',
            type: String
        },
        text: {
            default: null,
            type: String
        },
        title: {
            default: 'Dialog',
            type: String
        },
        parent: {
            default: null
        },
        persistent: {
            type: Boolean,
            default: false
        },
        preventCloseOnAccept: {
            type: Boolean,
            default: false
        },
        ignoreValidation: {
            type: Boolean
        }
    },
    watch: {
        active() {
            this.tryInsertBody()
        }
    },
    data() {
        return {}
    },
    computed: {
        buttonsHidden() {
            return !this.showAccept && !this.showCancel && !this.$slots['footer']
        },
        showAccept() {
            return this.$listeners['accept']
        },
        showCancel() {
            return this.$listeners['cancel']
        },
        styleHeader() {
            return {
                color: _color.getColor(this.color, 1)
            }
        },
        styleAfter() {
            return {
                background: _color.getColor(this.color, 1)
            }
        },
        parent_x() {
            return this.parent ? this.parent : document.body
        }
    },
    methods: {
        tryInsertBody() {
            this.$nextTick(() => {
                if (this.active) {
                    let elx = this.$refs.con
                    const olderSibling = this.parent_x.querySelector(':scope > .con-vs-dialog')
                    let referenceElement =
                        (olderSibling && olderSibling.nextSibling) || this.parent_x.firstChild

                    this.parent_x.insertBefore(elx, referenceElement)
                }
            })
        },

        async acceptDialog() {
            if (this.ignoreValidation) {
                this.accept()
                return
            }
            var validated = await this.validate()
            if (!validated || (!this.isValid && this.isValid != 'none')) {
                this.rebound()
                return
            }

            if (!this.preventCloseOnAccept) {
                this.$emit('update:active', false)
            }
            this.accept()
        },
        async accept() {
            var acceptor = this.$listeners['accept']
            if (!acceptor) {
                return
            }

            var acceptorResponse = acceptor()
            if (!acceptorResponse || !acceptorResponse.then) {
                return
            }

            try {
                this.loading = true
                await acceptorResponse
            } finally {
                this.loading = false
            }
        },
        handleClickOutside() {
            if (this.persistent) {
                this.rebound()
                return
            }
            this.handleClose()
        },
        handleClose() {
            this.$emit('update:active', false)
            this.$emit('close')
        },
        handleCancel() {
            this.handleClose()
            this.$emit('cancel')
        }
    },
    mounted() {
        this.tryInsertBody()
    },
    beforeDestroy() {
        // close the left open prompt
        let elx = this.$refs.con
        if (elx && this.parent_x.contains(elx)) {
            this.parent_x.removeChild(elx)
        }
    }
}
</script>

<style lang="scss" scoped>
.disabled {
    pointer-events: none;
    background-color: lightgray !important;
    color: gray !important;
}

.con-vs-dialog .vs-dialog {
    max-width: 90vw !important;
}
</style>
